module.exports = __webpack_public_path__ + "media/images/lp_v6_sec12_02-e4241151d9a75a4170ae5e764500c0a4.svg";